import React from 'react'
import { BadgeContainer } from './IsRostered.styles'

export const IsRosteredBadge = ({ isRostered, summaryView }) => {
  return !!summaryView ?
    <BadgeContainer summaryView={summaryView} isRostered={isRostered}>
      {isRostered ? "Yes" : "No"}
    </BadgeContainer>
    :
    isRostered ?
      <BadgeContainer>R</BadgeContainer> : <React.Fragment />
    
}